import { useEffect, useMemo } from 'react'
import { z } from 'zod'

import { useMe } from '@/hooks/features/user'
import { useUpdateLanguage } from '@/hooks/features/user/updateLanguage'
import i18n from '@/lib/i18n'

import { Language } from '../../i18n'

const schema = z.enum(['ja', 'en'])

export const useLanguage = () => {
  const { data: user } = useMe({})
  const { mutateAsync: updateLanguage } = useUpdateLanguage({})

  const language = useMemo((): Language => {
    if (user?.preferredLanguage) {
      return user.preferredLanguage
    }
    try {
      const parsedLanguage = schema.parse(i18n.language)
      return parsedLanguage
    } catch {
      return 'ja' // デフォルトは日本語
    }
  }, [user?.preferredLanguage])

  // Sync user's preferred language with i18n when user data is loaded
  useEffect(() => {
    if (user?.preferredLanguage && i18n.language !== user.preferredLanguage) {
      i18n.changeLanguage(user.preferredLanguage)

      // 言語変更時にページをリロード
      window.location.reload()
    }
  }, [user?.preferredLanguage])

  const changeLanguage = async (language: Language) => {
    await updateLanguage(language)
    i18n.changeLanguage(language)

    // 言語変更時にページをリロード
    window.location.reload()
  }

  return { language, changeLanguage }
}
